/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetBankAccountConfirmedActivities200ResponseInner
 */
export interface GetBankAccountConfirmedActivities200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'type': GetBankAccountConfirmedActivities200ResponseInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'usageFeeId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'cardBillId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'cardPointId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'serviceChargeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'pointAmount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'pointBalance'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'isConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'appliedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountConfirmedActivities200ResponseInner
     */
    'executedAt': string | null;
}

export const GetBankAccountConfirmedActivities200ResponseInnerTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY',
    serviceCharge: 'SERVICE_CHARGE'
} as const;

export type GetBankAccountConfirmedActivities200ResponseInnerTypeEnum = typeof GetBankAccountConfirmedActivities200ResponseInnerTypeEnum[keyof typeof GetBankAccountConfirmedActivities200ResponseInnerTypeEnum];


